import {
  BatteryHighIcon,
  BatteryMediumIcon,
  BatteryLowIcon,
  BatteryZeroIcon,
  ZeroLightIcon,
  LowLightIcon,
  MediumLightIcon,
  HighLightIcon,
  NewArrowUpIcon,
  NewArrowDownIcon,
} from '../Common/Icons';
import environmentalRanges from '../../../environmentalRanges.json';
import { DEVICE_MODEL_NUMBERS } from '@/constants/device';
import {
  _1,
  _2,
  _3,
  _4,
  _5,
  _6,
  _7,
  _8,
  _11,
  _12,
  _13,
  _14,
  _15,
  _16,
  _17,
  _18,
  _19,
  _20,
  _21,
  _22,
  _23,
  _24,
  _25,
  _26,
  _29,
  _30,
  _31,
  _32,
  _33,
  _34,
  _35,
  _36,
  _37,
  _38,
  _39,
  _40,
  _41,
  _42,
  _43,
  _44,
} from '../Common/Icons/WeatherIcons';
import { SensorDetailsTile } from '@/Components/Common/SensorDetailsTile';
import * as Icons from '../../../weatherIcons.json';
import { isNil, find, isUndefined, isEmpty, isNumber, toNumber } from 'lodash';

const weatherIconComponentMap = {
  _1,
  _2,
  _3,
  _4,
  _5,
  _6,
  _7,
  _8,
  _11,
  _12,
  _13,
  _14,
  _15,
  _16,
  _17,
  _18,
  _19,
  _20,
  _21,
  _22,
  _23,
  _24,
  _25,
  _26,
  _29,
  _30,
  _31,
  _32,
  _33,
  _34,
  _35,
  _36,
  _37,
  _38,
  _39,
  _40,
  _41,
  _42,
  _43,
  _44,
};

const componentMap = {
  BatteryZeroIcon,
  BatteryLowIcon,
  BatteryMediumIcon,
  BatteryHighIcon,
  ZeroLightIcon,
  LowLightIcon,
  MediumLightIcon,
  HighLightIcon,
};

const getIconComponent = (levels, value) => {
  if (isEmpty(levels)) return null;
  if (isNil(value) || !isNumber(value)) return componentMap[levels[0].component];
  const level = find(
    levels,
    (l) =>
      (!isUndefined(l.max) && value <= l.max) ||
      (!isUndefined(l.min) && value >= l.min && isUndefined(l.max))
  );
  return componentMap[isUndefined(level) ? levels[0].component : level.component];
};

export const battery = (batteryLevel, connectionStatus, connectionless = false) => {
  const IconComponent = getIconComponent(
    environmentalRanges.environmentalRanges.batteryLevels,
    batteryLevel
  );
  return IconComponent ? (
    <IconComponent connectionStatus={connectionStatus} connectionless={connectionless} />
  ) : null;
};

export const light = (val) => {
  if (isNil(val)) return;
  const lightVal = toNumber(val);
  if (!isNumber(lightVal)) return;
  const IconComponent = getIconComponent(
    environmentalRanges.environmentalRanges.lightLevels,
    lightVal
  );
  return IconComponent ? <IconComponent /> : null;
};

export const getLightLabel = (val) => {
  if (isNil(val)) return null;
  const lightVal = toNumber(val);
  if (!isNumber(lightVal)) return null;
  const level = find(
    environmentalRanges.environmentalRanges.lightLevels,
    (l) =>
      (!isUndefined(l.max) && lightVal <= l.max) ||
      (!isUndefined(l.min) && lightVal >= l.min && isUndefined(l.max))
  );
  return isUndefined(level) ? null : String(level.label).toUpperCase();
};

export const trendIcon = (trend) => {
  if (trend === undefined) return null;
  return trend === 'up' ? <NewArrowUpIcon /> : <NewArrowDownIcon />;
};

export const isEnvironmentalSensor = (sensor) => {
  return sensor.modelname === DEVICE_MODEL_NUMBERS.EM200;
};

export const renderWeatherIcon = (weatherIcon) => {
  if (!weatherIcon) return;
  const weatherIconKey = weatherIcon.toString();
  const WeatherIcon = weatherIconComponentMap[Icons[weatherIconKey]['WeatherIconID']];

  return <WeatherIcon />;
};

export const getSensorIcon = (data) => {
  const {
    location,
    zoneName,
    modelname,
    sensorStatus,
    batteryStatus,
    batteryLevel,
    deviceType,
    variant,
    connectionless = false,
  } = data;
  return (
    <SensorDetailsTile
      location={location}
      zoneName={zoneName}
      modelname={modelname}
      sensorStatus={sensorStatus}
      batteryStatus={batteryStatus}
      batteryLevel={batteryLevel}
      deviceType={deviceType}
      variant={variant}
      connectionless={connectionless}
    />
  );
};

export const isAlertWithin48Hours = (alert) => {
  const now = Date.now();
  const fortyEightHoursInMs = 48 * 60 * 60 * 1000;
  const timestamp = Date.parse(alert?.last_receivedtime_utc || '');
  if (Number.isNaN(timestamp)) {
    return false;
  }
  if (timestamp > now) {
    return false;
  }
  return now - timestamp <= fortyEightHoursInMs;
};
